module.exports = __webpack_public_path__ + "static/media/check_white.09bc86ac.svg";